import { CountriesCodeEnum, CountriesLocaleEnum } from "../../enumerations";
export default {
    [CountriesCodeEnum.AUSTRIA]: CountriesLocaleEnum.AUSTRIA,
    [CountriesCodeEnum.ENGLAND]: CountriesLocaleEnum.ENGLAND,
    [CountriesCodeEnum.GERMANY]: CountriesLocaleEnum.GERMANY,
    [CountriesCodeEnum.NETHERLANDS]: CountriesLocaleEnum.NETHERLANDS,
    [CountriesCodeEnum.SPAIN]: CountriesLocaleEnum.SPAIN,
};
//# sourceMappingURL=countries-locale.constants.js.map